import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.06,7.78H9A.74.74,0,0,1,8.29,7V2a.75.75,0,0,1,1.5,0V6.28h4.27a.75.75,0,0,1,0,1.5ZM7.77,14V9A.74.74,0,0,0,7,8.27H2a.75.75,0,0,0,0,1.5H6.27V14a.75.75,0,0,0,1.5,0Z';
const draw24px =
  'M20.53,4.49,15.6,9.42h3.21a.75.75,0,0,1,0,1.5h-5a.72.72,0,0,1-.29-.06.63.63,0,0,1-.24-.16.78.78,0,0,1-.16-.24.72.72,0,0,1-.06-.29v-5a.75.75,0,1,1,1.5,0V8.36l4.93-4.93a.75.75,0,1,1,1.06,1.06Zm-9.7,9.22a.74.74,0,0,0-.2-.38.78.78,0,0,0-.24-.16.72.72,0,0,0-.29-.06h-5a.75.75,0,1,0,0,1.5H8.29L3.36,19.54a.75.75,0,0,0,0,1.06.79.79,0,0,0,.53.22.75.75,0,0,0,.53-.22l4.93-4.93v3.21a.75.75,0,0,0,1.5,0v-5A.77.77,0,0,0,10.83,13.71Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowMinimizeIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowMinimize')) as IconWithRender;

ArrowMinimizeIcon.displayName = 'ArrowMinimizeIcon';
ArrowMinimizeIcon.propTypes = Icon.propTypes;
ArrowMinimizeIcon.renderIcon = (props) => <ArrowMinimizeIcon {...props} />;
export default ArrowMinimizeIcon;
